import { cn } from 'lib/utils';
import PropTypes from 'prop-types';
import magnifier from '../../images/icons/search.svg';
import TabButton from './tabbutton';

const SearchIcon = ({ className, closingSearch, openSearch }) => {
  return (
    <TabButton
      id="search-button"
      aria-label="Open search"
      className={cn(className)}
      onClick={openSearch}
      iconSrc={magnifier}
      ref={(button) => closingSearch && button?.focus()}
    >
      Search
    </TabButton>
  );
};

SearchIcon.propTypes = {
  className: PropTypes.string,
  closingSearch: PropTypes.bool,
  openSearch: PropTypes.func.isRequired,
};

export default SearchIcon;
